import classNames from "classnames";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { IconSize } from "~/common/mui/icons/IconSize";
import { type SvgIconProps } from "~/common/mui";

export interface Props extends Omit<SvgIconProps, "fontSize"> {
  isActive?: boolean;
  size?: IconSize | number;
}

const iconSizeToFontSize = (size: IconSize | number = IconSize.FONT_16): number => {
  if (typeof size === "number") {
    return size;
  }

  switch (size) {
    case IconSize.FONT_10:
      return 10;
    case IconSize.FONT_20:
      return 20;
    case IconSize.FONT_24:
      return 24;
    case IconSize.FONT_30:
      return 30;
    case IconSize.FONT_50:
      return 50;
    case IconSize.FONT_64:
      return 64;
    case IconSize.FONT_16:
    default:
      return 16;
  }
};

const getIconSx = (sx: SvgIconProps["sx"], size?: IconSize | number): SvgIconProps["sx"] => {
  const fontSizeSx = { fontSize: iconSizeToFontSize(size) };

  if (!sx) {
    return fontSizeSx;
  }

  const sxArray = Array.isArray(sx) ? sx : [sx];

  return [...sxArray, fontSizeSx] as SvgIconProps["sx"];
};

export const ToggleIcon = ({ isActive, className, size, sx, ...rest }: Props) => {
  const IconComponent = isActive ? KeyboardArrowUpIcon : KeyboardArrowDownIcon;

  return (
    <IconComponent {...rest} className={classNames(className, "d-flex")} sx={getIconSx(sx, size)} />
  );
};
